<template>
    <div>
        <form-row title="Listing Fee" :no_border="true" class="my-8 sm:my-6">
            <div class="flex-wrap flex flex-1 items-center">
                <div class="w-1/3 sm:w-1/5">
                    <input-percent
                        name="list_side_percent_fee"
                        v-model="list_side_percent_fee"
                        placeholder="Fee"
                        :read_only="read_only"
                    />
                </div>

                <div class="w-2/3 sm:w-2/5 flex sm:flex-1 items-center">
                    <div class="text-sm text-gray-600 pl-2">
                        {{ $t(gross_or_net + ' of sale price') }}
                    </div>

                    <div class="hidden sm:flex flex-1 items-center justify-center">
                        <i class="text-sm text-green-warm-500 fas fa-equals"></i>
                    </div>
                </div>

                <div class="w-1/5 sm:hidden flex items-center justify-center">
                    <i class="text-sm text-green-warm-500 fas fa-equals"></i>
                </div>

                <div class="w-4/5 mt-4 sm:mt-0 sm:w-2/5">
                    <input-money
                        name="list_side_list_revenue"
                        :value="list_side_list_revenue"
                        :read_only="true"
                        tabindex="-1"
                    />
                </div>
            </div>
        </form-row>

        <div class="border-b border-gray-400 md:ml-46 sm:mb-6"></div>
    </div>
</template>

<script>
import MoneyFunctions from '../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    props: {
        commission_detail: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            list_side_percent_fee: this.commission_detail.list_side_percent_fee,
        }
    },

    computed: {
        gross_or_net() {
            return store.state.fees_paid_gross ? 'gross' : 'net';
        },
        purchase_price() {
            return this.moneyVal(store.state.purchase_price);
        },
        net_sale_price() {
            return this.moneyVal(store.state.net_sale_price);
        },
        fees_paid_gross() {
            return store.state.fees_paid_gross;
        },
        list_side_list_revenue() {
            if (! this.list_side_percent_fee) {
                return null;
            }

            return this.formatMoney(
                (this.list_side_percent_fee / 100) * (
                    this.fees_paid_gross
                        ? parseFloat(this.purchase_price)
                        : parseFloat(this.net_sale_price)
                ));
        },
    },

    watch: {
        list_side_list_revenue(val) {
            this.$emit('updated', val);
        },
    },
}
</script>
